import { getApiPurewaveSetting, putApiPurewaveSetting } from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const myWaveQuery = createQuery({
  handler: getApiPurewaveSetting,
})

export const myWaveUpdate = createMutation({
  handler: putApiPurewaveSetting,
})
